import { useEffect } from "react";
import SkillsContainer1 from "./skills-container1";
import "./skills-container.css";

const SkillsContainer = () => {
  useEffect(() => {
    const scrollAnimElements = document.querySelectorAll(
      "[data-animate-on-scroll]"
    );
    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting || entry.intersectionRatio > 0) {
            const targetElement = entry.target;
            targetElement.classList.add("animate");
            observer.unobserve(targetElement);
          }
        }
      },
      {
        threshold: 0.15,
      }
    );

    for (let i = 0; i < scrollAnimElements.length; i++) {
      observer.observe(scrollAnimElements[i]);
    }

    return () => {
      for (let i = 0; i < scrollAnimElements.length; i++) {
        observer.unobserve(scrollAnimElements[i]);
      }
    };
  }, []);
  return (
    <div
      className="frame-parent"
      data-scroll-to="frameContainer2"
      data-animate-on-scroll
    >
      <div className="skills-wrapper">
        <div className="skills1">Skills</div>
      </div>
      <SkillsContainer1 technologyIcon="Figma" languageProficiency="80%" />
      <SkillsContainer1
        technologyIcon="C/C++"
        languageProficiency="75%"
        propLeft="569px"
        propTop="122px"
        propLeft1="calc(50% + 191.5px)"
        propWidth="332px"
      />
      <SkillsContainer1
        technologyIcon="Python"
        languageProficiency="70%"
        propLeft="24px"
        propTop="268px"
        propLeft1="calc(50% + 191.5px)"
        propWidth="323px"
      />
      <SkillsContainer1
        technologyIcon="Java"
        languageProficiency="60%"
        propLeft="569px"
        propTop="268px"
        propLeft1="calc(50% + 189.5px)"
        propWidth="272px"
      />
      <SkillsContainer1
        technologyIcon="HTML, CSS"
        languageProficiency="60%"
        propLeft="24px"
        propTop="414px"
        propLeft1="calc(50% + 189.5px)"
        propWidth="272px"
      />
      <SkillsContainer1
        technologyIcon="Video Editing"
        languageProficiency="80%"
        propLeft="569px"
        propTop="414px"
        propLeft1="calc(50% + 189.5px)"
        propWidth="367px"
      />
      <img className="frame-child" alt="" src="/vector-31.svg" />
      <img className="frame-item" alt="" src="/vector-33.svg" />
      <img className="frame-inner" alt="" src="/vector-35.svg" />
      <img className="vector-icon" alt="" src="/vector-34.svg" />
      <img className="frame-child1" alt="" src="/vector-32.svg" />
    </div>
  );
};

export default SkillsContainer;
